import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const Date = (props) => (
  <span>{format(props.value, props.format, { locale: es })}</span>
);

export default Date;
